import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let GrasaService = class GrasaService {
    constructor(http) {
        this.http = http;
        this.cargadoGrasa = true;
        this.grasa = [];
        this.grasaRFL = [];
        this.grasaRFC = [];
        this.grasaRFP = [];
        this.grasaRCL = [];
        this.grasaRCC = [];
        this.grasaRCP = [];
        this.cargarGrasa();
    }
    cargarGrasa() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.grasa = resp;
                this.grasaRFL = this.grasa[4].rutinafacial.limpieza;
                this.grasaRFC = this.grasa[4].rutinafacial.cuidado;
                this.grasaRFP = this.grasa[4].rutinafacial.proteccion;
                this.grasaRCL = this.grasa[4].rutinacorporal.limpieza;
                this.grasaRCC = this.grasa[4].rutinacorporal.cuidado;
                this.grasaRCP = this.grasa[4].rutinacorporal.proteccion;
                setTimeout(() => {
                    this.cargadoGrasa = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
GrasaService.ctorParameters = () => [
    { type: HttpClient }
];
GrasaService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], GrasaService);
export { GrasaService };
//# sourceMappingURL=grasa.service.js.map